import { TEN, TWO } from 'bento-ordering/base/constants/grid';

export const HORIZONTAL_PADDING = { md: TEN, xs: TWO };
export const DEFAULT_LAYOUT_PADDING = {
  pl: HORIZONTAL_PADDING,
  pr: HORIZONTAL_PADDING,
  pt: 2.5,
  pb: 2.5
};

export const MENU_LAYOUT_PADDING = {
  pl: HORIZONTAL_PADDING,
  pr: HORIZONTAL_PADDING,
  pt: 0,
  pb: 2.5,
  mt: -1.5
};
